export default __webpack_public_path__ + "static/media/Star.ad40e06a.svg";